module.exports = __webpack_public_path__ + "static/media/Тезисы УОМШ-2025. Том 1.53a626fd.pdf";